"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _TrackingCodeActions = require("../actions/TrackingCodeActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  basicTrackingCode: '',
  advancedTrackingCode: ''
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _TrackingCodeActions.FetchBasicTrackingCodeActionTypes.SUCCESS, function (state, action) {
  return state.set('basicTrackingCode', action.payload.data);
}), (0, _defineProperty2.default)(_handleActions, _TrackingCodeActions.FetchAdvancedTrackingCodeActionTypes.SUCCESS, function (state, action) {
  return state.set('advancedTrackingCode', action.payload.data);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;